/* ==========================================================================
  main.js
========================================================================== */

/**
 * Init dropdown-menus
 */
var dropdown_menus = document.querySelectorAll('.js-navigation');
for (var i = 0; i < dropdown_menus.length; i++) {
  component_dropdown_menu({
    desktop_min_width: 890,
    menu: dropdown_menus[i]
  });
}

/**
 * Init mobile menu
 */
component_mobile_menu({
  menu:     document.querySelector('.js-mobile-menu'),
  site:     document.querySelector('.js-page'),
  toggles:  document.querySelectorAll('.js-menu-toggle')
});

/**
 * Init Responsive videos
 */
fitvids();

/**
 * Init a11y dialog
 */
 component_a11y_dialog();

/**
 * Init polyfill object-fit for lazyloaded
 */
if (typeof objectFitPolyfill === "function") {
  document.addEventListener('lazybeforeunveil', function(e){
    objectFitPolyfill();
    e.target.addEventListener('load', function() {
      objectFitPolyfill();
    });
  });
}

/**
 * Init lightbox
 */
if (document.querySelectorAll('.lightbox').length) {
  try {
    new Tobi({
      // variables from script localization in register-assets.php
      navLabel: [theme_strings.prev, theme_strings.next],
      closeLabel: theme_strings.close,
      loadingIndicatorLabel: theme_strings.loading,
      captionsSelector: 'self',
      captionAttribute: 'data-caption',
      zoom: false,
    });
  } catch (e) {
    console.log(e);
  }
}



document.addEventListener("DOMContentLoaded", (event) => {
  jQuery(function() {

    // a11y toggle animation
    jQuery('.toggle-button').click(function(){

      var toggle_target = jQuery(this).attr('data-a11y-toggle');

      if(jQuery(this).hasClass('toggle-button-not-found')) {

        var toggle_target_element = document.getElementById(toggle_target);

        if ( jQuery(toggle_target_element).attr('aria-hidden') == 'true' ) {
          jQuery('#' + toggle_target).slideToggle(250);
        }

      } else {
        jQuery('#' + toggle_target).slideToggle(250);
      }

    });

    jQuery(document).on('click', 'a[href^="#"]', function (event) {
      event.preventDefault();

      jQuery('html, body').animate({
          scrollTop: jQuery(jQuery.attr(this, 'href')).offset().top
      }, 500);
    });

    /* prevent scroll to anchor https://stackoverflow.com/questions/3659072/how-to-disable-anchor-jump-when-loading-a-page */
    // store the hash (DON'T put this code inside the jQuery() function, it has to be executed
    // right away before the browser can start scrolling!

    var target = window.location.hash,
    target = target.replace('#', '');

    if (window.location.hash === '#kartta' || window.location.hash === '#lista') {

      // delete hash so the page won't scroll to it
      window.location.hash = "";

      // now whenever you are ready do whatever you want
      // (in this case I use jQuery to scroll to the tag after the page has loaded)
      jQuery(window).on('load', function() {

        if (target) {
          window.scrollTo(0, 0);
        }
      });
    }
  });
});

